import styled from 'styled-components';
import Card from 'components/Card';
import Button from 'components/Button';
import { H2, H4, P } from 'components/Typography';
import { th } from 'style/theme';
import { sizes } from 'style';

export const ClaimsContainer = styled.div`
  color: ${th('colors.black')};
`;

export const Content = styled.div`
  margin-top: 40px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  row-gap: 40px;

  @media ${sizes.tabletPortrait} {
    margin-top: 60px;
    row-gap: 80px;
  }
`;

export const Step = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  max-width: 350px;

  p {
    color: ${th('colors.black')};
  }
`;

export const StepNumber = styled.div`
  border-radius: 50%;
  border: 2px solid ${th('colors.black')};
  min-width: 35px;
  min-height: 35px;
  text-align: center;
  font-weight: bold;

  > span {
    position: relative;
    top: 6px;
  }
`;

export const StepContent = styled.div`
  margin-left: ${th('space.5')}px;
`;

export const StepContentTitle = styled(H2)`
  font-size: 1.5em;
  margin: 8px 0;

  @media ${sizes.tabletPortrait} {
    margin: 1em 0;
  }
`;

export const StepContentText = styled(P)`
  margin: 1em 0;
`;

export const StepContentBoldText = styled.span`
  font-weight: bold;
`;

export const StepContentSmallText = styled(P)`
  font-size: 0.9em;
  margin: 1em 0;
`;

export const Image = styled.div`
  display: inline-block;

  > img {
    width: 80px;
    height: 80px;

    @media ${sizes.tabletPortrait} {
      width: 100px;
      height: 100px;
    }
  }
`;

export const Divider = styled.hr`
  width: 100%;
  height: 2px;
  border: none;
  background-color: ${th('colors.black')};
  margin-top: ${th('space.15')}px;
  margin-bottom: ${th('space.15')}px;
`;

export const ModalText = styled.div`
  margin-bottom: 8px;
  color: inherit;
`;

export const ModalCard = styled(Card)`
  word-break: break-word;
  padding: 16px;

  @media ${sizes.tabletPortrait} {
    padding: 24px;
  }

  > * {
    color: ${th('colors.white')};
  }
`;

export const ClaimDisclaimerText = styled(H4)`
  font-size: 1em;
  margin: 1em 0;
`;

export const ModalOpenLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;

export const StartButton = styled(Button)`
  margin-top: 12px;
`;
